import React, { useState, useEffect } from "react";

import CallToAction from "./js/components/CallToAction";
import Footer from "./js/components/Footer";
import LinksUteis from "./js/components/LinksUteis";
import NavBar from "./js/components/NavBar";
import Relatorios from "./js/components/Relatorios";
import Slider from "./js/components/Slider";

import Indicadores from "./js/pages/indicadores";
import Mapas from "./js/pages/mapas";
import FaleConosco from "./js/pages/faleConosco";
import PaineisControle from './js/pages/paineisControle/index'
import Login from "./js/pages/login/Login";
import GeradorRelatorios from "./js/pages/geradorRelatorios/index";

const App = (props) => {

  const [values, setValues] = useState({
    relatorios: false,
    indicadores: false,
    mapas: false,
    faleConosco: false,
    painelControle: false,
    home: true,
  });

  const [data, setData] = useState()

  const [visible, setVisible] = useState(true);

  const [menuDisplay, setMenuDisplay] = useState(true)

  const handleRelatorios = () => {

    setValues({
      ...values,
      relatorios: true,
      indicadores: false,
      mapas: false,
      faleConosco: false,
      painelControle: false,
      home: false,
    });

  };

  const handleIndicadores = () => {

    setValues({
      ...values,
      relatorios: false,
      indicadores: true,
      mapas: false,
      faleConosco: false,
      painelControle: false,
      home: false,
    });

  };
  const handleMapas = () => {

    setValues({
      ...values,
      relatorios: false,
      mapas: true,
      indicadores: false,
      faleConosco: false,
      painelControle: false,
      home: false,
    });
  };
  const handleFaleConosco = () => {
    setValues({
      ...values,
      relatorios: false,
      faleConosco: true,
      mapas: false,
      indicadores: false,
      painelControle: false,
      home: false,
    });
  };

  const handlePaineisControle = () => {

    setValues({
      ...values,
      relatorios: false,
      faleConosco: false,
      mapas: false,
      indicadores: false,
      painelControle: true,
      home: false,
    });
  };

 

  //const { indicadores, mapas, faleConosco, painelControle, home } = values;

  return (
    <>
      <NavBar/>

      {values.home ? <>
        <CallToAction
          handleIndicadores={handleIndicadores}
          setVisible={setVisible}
          handleMapas={handleMapas}
          handleFaleConosco={handleFaleConosco}
          handlePaineisControle={handlePaineisControle}
          handleRelatorios={handleRelatorios}/>
        <Slider />
        <Relatorios />
        <LinksUteis />
      </> : null}


      {values.login ? <Login/>: null}
      {values.indicadores ? <Indicadores /> : null}
      {values.relatorios ? <GeradorRelatorios /> : null}
      {values.mapas ? <Mapas /> : null}
      {values.faleConosco ? <FaleConosco /> : null}
      {values.painelControle ? <PaineisControle /> : null}


      <Footer
        handleIndicadores={handleIndicadores}
        setVisible={setVisible}
        handleMapas={handleMapas}
        handleFaleConosco={handleFaleConosco}
        handlePaineisControle={handlePaineisControle}
        handleRelatorios={handleRelatorios}/>
    </>
  );
};

export default App;
